import { useReduxState } from 'hooks';
import { ApiDownloadButton, MoreOptions } from 'components/common';
import { CourseViewVersion } from 'components/courses/common';
import {
  FollowUsersAllowNewAttempt,
  FollowUsersDeleteAnalytics,
  FollowUsersDownloadAnswers,
  FollowUsersEditCompletion,
  FollowUsersToggleComplete
} from '.';

import type { GetTaskUsersRes } from 'shared-types/responses';

interface Props {
  user: GetTaskUsersRes['users'][number];
  updateUsers: () => Promise<void>;
}

const FollowUsersListActions = ({ user, updateUsers }: Props) => {
  const {
    language,
    messages,
    pageState: { course },
    serverConfig: { courseCompletionAllowEdit }
  } = useReduxState();

  return (
    <MoreOptions styleContentButtons={false} renderInPortal={true}>
      {!user.isAnonymous ? (
        <>
          {courseCompletionAllowEdit &&
          !user.progressData?.completion?.inactive &&
          user.progressData?.completion?.status === 'success' ? (
            <FollowUsersEditCompletion
              completion={user?.progressData?.completion}
              isDropdown={true}
              updateUsers={updateUsers}
              userId={user.id}
            />
          ) : null}

          {user?.progressData?.completion?.courseVersion &&
          user.progressData.completion.status !== 'inprogress' ? (
            <CourseViewVersion
              completionId={user.progressData.completion.id}
              courseSlug={course.slug}
              courseVersion={
                user.progressData.completion.courseVersion as string
              }
            />
          ) : null}

          <FollowUsersToggleComplete
            course={course}
            isDropdown={true}
            participant={user}
            updateUsers={updateUsers}
          />

          {user.progressData.completion &&
          !user.progressData.completion.inactive &&
          user.progressData.completion.status === 'failed' ? (
            <FollowUsersAllowNewAttempt
              courseId={course.id}
              onUpdate={updateUsers}
              userId={user.id}
            />
          ) : null}
        </>
      ) : null}

      {user.progressData.completion &&
      !user.progressData.completion.inactive &&
      user.progressData.completion.status === 'success' ? (
        <ApiDownloadButton
          filename={`${user.email || user.username}-cert.pdf`}
          icon="file-pdf"
          isDropdown={true}
          text={messages.completionsDownloadCertificate}
          url={
            `/admin/certificate` +
            `?completionId=${user.progressData.completion.id}` +
            `&language=${language}`
          }
        />
      ) : null}

      <FollowUsersDownloadAnswers
        courseId={course.id}
        includeReviews={course.tasksIncludeReviews}
        isAdmin={true}
        isDropdown={true}
        user={user}
      />

      <FollowUsersDeleteAnalytics
        courseId={course.id}
        onDelete={updateUsers}
        userId={user.id}
      />
    </MoreOptions>
  );
};

export default FollowUsersListActions;
